<!-- <button (click)="openDialog('test')">click me </button> -->
<div class="container-fluid page" *ngIf="!formhide">
  <div class="d-flex page__box p-3 mt-2">&nbsp; Government Schemes<div class="export_csv"
      style="margin-bottom: 5px !important;">
      <div class="add_button_text"><button class="add_button_new pull-right" (click)="formPage()" mat-raised-button
          color="primary">Add New
          Scheme</button></div>&nbsp;&nbsp;<button class="clear_button_export" (click)="openDialogexport()"
        style="float: right;margin-top: -36px;" mat-raised-button color="primary">Export</button>
    </div>
  </div>
  <div class="page__content shadow p-3 ">

    <div>
      <br />
      <div class="row" style="margin-top: -40px;">
        <div class="col-3 topData">
          <p>Total schemes published</p>
          <p style="font-size: 2rem;">{{avgCount.totalCount}}</p>
        </div>
        <div class="col-3 topData">
          <p>Posted this year</p>
          <p style="font-size: 2rem;">{{avgCount.postedthisyear}}</p>
        </div>
        <div class="col-9 pull-right">

        </div>
      </div>

      <mat-card>

        <div class="example-header" *ngIf="filtershow">
          <mat-form-field class="full-width-field" style="width: 50% !important;">
            <input matInput [(ngModel)]="searchData" (change)="changeFn($event)" placeholder="Search">
          </mat-form-field>&nbsp;&nbsp;

          <button type="submit" (click)="applyfilter(true)" class="btn btn-primary mat-primary search_bar">
            <mat-icon class="search_bar_icon">search</mat-icon>
          </button>

          <hr>

          <mat-form-field>
            <input matInput [(ngModel)]="categoryname" placeholder="Category Name">
          </mat-form-field>&nbsp;&nbsp;

      
          <mat-form-field>
            <input matInput type="text" name="daterange" placeholder="Date Range" [min]="minDate" autocomplete="off"
              [max]="maxDate" [alwaysShowCalendars]="true" ngxDaterangepickerMd [(ngModel)]="sharedate"
               [showCustomRangeLabel]="true" [ranges]="ranges"
              (change)="onDateRangeChanged(sharedate)" />
          </mat-form-field>

          <button class="btn btn-primary mat-primary clear_button pull-right" style="margin-top: 12px;"
            (click)="clearFilter()">Clear Filter</button>
          <button type="submit" style="margin-top: 12px; margin-right: 10px;" (click)="applyfilter(true)"
            class="btn btn-primary mat-primary pull-right">Apply Filter </button>

          <mat-chip-list #chipList aria-label="Filter selection">
            <mat-chip *ngFor="let filter of matChipArray;let i=index" [selectable]="selectable" [removable]="removable"
              (removed)="remove(i,filter.tag)">
              {{filter.name}}
              <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>

          <div class="text_filter_data" *ngIf="exportcsvdata">
            <p *ngIf="this.length == 0"> There's no record found with the given criteria,
              please try again refining your search and filters </p>
          </div>
        </div>
      </mat-card>
      <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">

        <mat-table #table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="schemtTitle">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Title </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              {{GovernmentSchemes.schemtTitle}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="categoryName">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Category Name </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              {{GovernmentSchemes.categoryName}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dateposted">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Date Posted </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              {{GovernmentSchemes.dateposted.split(' ')[0]}}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="attachLink">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Attached Link </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              <span style="width:200px" *ngIf="GovernmentSchemes.attachLink !=null">
                <a target="_blank" href="{{GovernmentSchemes.attachLink}}">
                  Available link</a>
              </span>
              <span *ngIf="GovernmentSchemes.attachLink == null">
                <p></p>
              </span>

            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="attachedFile">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Attached Document </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              <span style="width:200px" *ngIf="GovernmentSchemes.attachedFile != null">
                <a target="_blank" href="{{GovernmentSchemes.attachedFile}}" class="links">Available</a>
              </span>
              <span *ngIf="GovernmentSchemes.attachedFile == null">
                <p style="margin-top: 12px !important;">Unavailable</p>
              </span>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="updatedBy">
            <mat-header-cell mat-sort-header *matHeaderCellDef> Updated By </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">{{GovernmentSchemes.createdBy}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
            <mat-cell *matCellDef="let GovernmentSchemes">
              <div>
                <mat-icon class="colorchange" (click)="edit(GovernmentSchemes)">edit</mat-icon>&nbsp;&nbsp;&nbsp;
                <mat-icon class="colorchange" (click)="openDialog(GovernmentSchemes.id)">delete</mat-icon>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <div>
          <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)" [pageSize]="[10]"
            [pageSizeOptions]="[ 10, 25, 100]" showFirstLastButtons aria-label="" class="pagination">
          </mat-paginator>
        </div>

      </div>
    </div>

  </div>
</div>

<div class="container-fluid page" *ngIf="formhide">

  <div class="d-flex page__box p-3 mt-2"> <img src="./assets/arrow_logo.png" class="arrow" (click)="listPage()">&nbsp;
    Update Government Scheme</div>

  <div class="example-header" style="height: 556px;">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="formedit">
          <div class="fulllwidth">

            <input type="hidden" formControlName="id">

            <mat-form-field>
              <input type="text" formControlName="SchemtTitle" required matInput placeholder="Scheme Title">
              <!-- <mat-error *ngIf="formedit.get('SchemtTitle').hasError('required')">
              </mat-error> -->
            </mat-form-field>

            <mat-form-field>
              <textarea matInput required style="resize: none !important;" formControlName="Description" (keyup)="descriptionchange($event.target.value)"
                placeholder="Description"></textarea>
              <mat-error *ngIf="formedit.get('Description').hasError('required')">
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-select formControlName="CategoryID" required placeholder="Category">
                <mat-option *ngFor="let opt of categorydatalist" (click)="getcategoryId(opt.categoryID)"
                  [value]="opt.categoryName">
                  {{opt.categoryName}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <input type="text" formControlName="Attachedlink" placeholder="Add a reference link" matInput>
            </mat-form-field>

            <!-- <mat-form-field>
              <input type="text" formControlName="Remark" placeholder="Remark" matInput>
            </mat-form-field> -->
            <div class="row">
              <div class="col-12" style="margin-bottom: 10px;">
                <div class="col-12">
                  <p class="pull-left" style="    width: 100%;
                    text-align: left;">Attach a reference document: A single PDF document or an image file (PNG, JPEG/JPG)</p>
                </div>
                <div class="col-12">
                  <input class="col-6  pull-left" (change)="processImage($event)" type="file" #inputFile>
                  <button class="col-1 pull-left" (click)="removeFile()" *ngIf="isButtonVisible"
                    matTooltip="remove attachment" style="border: none;" mat-stroked-button aria-label="remove file">
                    <mat-icon [ngStyle]="{'color':'red'}">clear</mat-icon>
                  </button>
                </div>
              </div>
              <span *ngIf="attachfile != null">
                <a target="_blank" href="{{attachfile}}">
                  Previous Upload File </a>
              </span>
              <div class="col-md-12">
                <button class="pull-right submitBtn" style="color: white;" (click)="onSubmit()" mat-button type="submit"
                  [disable]="disable">Post</button>
              </div>
            </div>

            <div *ngIf="requirederror">Please Enter Mandatory Fields</div>
          </div>
        </form>
      </mat-card-content>

    </mat-card>
  </div>
</div>
